import React, { useEffect, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import { FaCheckDouble } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import ResponsiveList, { CardTitle, CardField, CardActions } from '../../Components/Shared/ResponsiveList';
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;

const Approval = () => {

    //#region Const

    let navigate = useNavigate();

    const [ShowLoading, setShowLoading] = useState(true);
    const [Data, setData] = useState([]);

    const [ShowRejectModal, setShowRejectModal] = useState(false);
    const [RejectId, setRejectId] = useState(General.GuidEmpty());
    const [RejectReason, setRejectReason] = useState("");
    //#endregion

    //#region Methods

    const Bind = () => {
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Task/Search?title=",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "assignTo": General.GuidEmpty(),
                "unassigned": false,
                "projectId": General.GuidEmpty(),
                "categoryId": General.GuidEmpty(),
                "state": Enum.TaskStateType.Delivered,
                "priority": 0,
                "beginDate": '',
                "endDate": ''
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                //--> قدیمی ترین ها بالای صف باشند تا در ته لیست فراموش نشوند
                var sorted = [...res.data].sort((a, b) => {
                    var keyA = (a.lastUpdateDate || '') + (a.lastUpdateTime || '');
                    var keyB = (b.lastUpdateDate || '') + (b.lastUpdateTime || '');
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                });
                setData(sorted);
                setShowLoading(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoading(false);
                }
            })
    }

    const Approve = (taskId) => {
        setShowLoading(true);
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/Task/Approve",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: taskId
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                if (res.data.isSuccess) {
                    Bind();
                }
                else {
                    setShowLoading(false);
                    General.ShowMsg(Enum.MsgType.error, res.data.error);
                }
            })
            .catch(error => {
                setShowLoading(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    const OpenReject = (taskId) => {
        setRejectId(taskId);
        setRejectReason("");
        setShowRejectModal(true);
    }

    const SubmitReject = () => {
        if (!RejectReason || !RejectReason.trim()) {
            General.ShowMsg(Enum.MsgType.error, "دلیل رد کردن وظیفه را وارد نمایید");
            return;
        }
        setShowLoading(true);
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/Task/Reject?comment=" + encodeURIComponent(RejectReason),
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: RejectId
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                if (res.data.isSuccess) {
                    setShowRejectModal(false);
                    Bind();
                }
                else {
                    setShowLoading(false);
                    General.ShowMsg(Enum.MsgType.error, res.data.error);
                }
            })
            .catch(error => {
                setShowLoading(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    useEffect(() => {
        Bind();
    }, [])
    //#endregion

    return (
        <Shared pageTitle={<><FaCheckDouble size={25} /> تایید وظایف</>}>
            <div align="left">
                <rsuite.Button appearance="primary" color="green" className="mb-2 ms-2" onClick={Bind}>
                    بازسازی
                </rsuite.Button>
            </div>
            <rsuite.Divider />
            <ResponsiveList
                fillHeight
                data={Data}
                loading={ShowLoading}
                emptyText="وظیفه ای منتظر تایید نیست"
                filters={[
                    { key: 'title', label: 'عنوان', type: 'text' },
                    { key: 'assignToFullName', label: 'مسئول انجام', type: 'text' },
                    { key: 'projectTitle', label: 'پروژه', type: 'text' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>{rowData.title}</CardTitle>
                        <CardField label="مسئول انجام">{rowData.assignToFullName}</CardField>
                        <CardField label="پروژه">{rowData.projectTitle} · {rowData.categoryTitle}</CardField>
                        <CardField label="مهلت انجام">
                            {
                                rowData.isOverdue ?
                                    <rsuite.Tag color="red">{rowData.dueDate}</rsuite.Tag>
                                    :
                                    rowData.dueDate
                            }
                        </CardField>
                        <CardActions>
                            <rsuite.Button size="sm" appearance="primary" color="green"
                                onClick={() => Approve(rowData.id)}>تایید</rsuite.Button>
                            <rsuite.Button size="sm" appearance="primary" color="red" className='ms-2'
                                onClick={() => OpenReject(rowData.id)}>رد</rsuite.Button>
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    //--> ارتفاع سطر با طول عنوان بالا می رود تا عنوان بلند بریده نشود
                    rowHeight={RowHeight}
                    wordWrap="break-word"
                    data={Data}
                    loading={ShowLoading}
                >
                    <Column>
                        <HeaderCell><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>
                    <Column flexGrow={3}>
                        <HeaderCell><b>عنوان</b></HeaderCell>
                        <Cell dataKey="title" />
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>مسئول انجام</b></HeaderCell>
                        <Cell dataKey="assignToFullName" />
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>پروژه / دسته بندی</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <>
                                    <div>{rowData.projectTitle}</div>
                                    <div>{rowData.categoryTitle}</div>
                                </>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>مهلت انجام</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                rowData.isOverdue ?
                                    <rsuite.Tag color="red">{rowData.dueDate}</rsuite.Tag>
                                    :
                                    <span>{rowData.dueDate}</span>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>آخرین به روز رسانی</b></HeaderCell>
                        <Cell dataKey="lastUpdateDate" />
                    </Column>
                    <Column width={200} fixed="right">
                        <HeaderCell>عملیات</HeaderCell>
                        <Cell>
                            {rowData => (
                                <>
                                    <rsuite.Button appearance="primary" color="green" size="xs" className="me-1"
                                        onClick={() => Approve(rowData.id)}>
                                        تایید
                                    </rsuite.Button>
                                    <rsuite.Button appearance="primary" color="red" size="xs"
                                        onClick={() => OpenReject(rowData.id)}>
                                        رد
                                    </rsuite.Button>
                                </>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>

            <rsuite.Modal open={ShowRejectModal} onClose={() => setShowRejectModal(false)} size="sm">
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title>دلیل رد کردن وظیفه</rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <rsuite.Input as="textarea" rows={4} className="w-100"
                        value={RejectReason} onChange={value => setRejectReason(value)} />
                </rsuite.Modal.Body>
                <rsuite.Modal.Footer>
                    <rsuite.Button appearance="primary" color="red" onClick={SubmitReject}>ثبت</rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowRejectModal(false)}>انصراف</rsuite.Button>
                </rsuite.Modal.Footer>
            </rsuite.Modal>
        </Shared>
    );
}

export default Approval;
